import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useAuth } from 'context/auth';

function AdminRoute({ component: Component, ...rest }) {
  const { refresh } = useAuth();
  const user = useSelector(state => state.user);
  
  return (
    <Route
      {...rest}
      render={(props) =>
        refresh ? (
          user.userData.isAdmin ? (
            <Component {...props} />
          ) : (
            <Redirect to={{ pathname: '/' }} />
          )
        ) : (
          <Redirect to={{ pathname: '/auth/login' }} />
        )
      }
    />
  );
}

export default AdminRoute;
